import leftPad from 'left-pad';
import trimZero from './trimZero';

// it will convert seconds to 'HH:MM:SS' format
const convertToTime = (seconds) => {
    const pHours = Math.floor(seconds / (60 * 60));
    const pMinutes = Math.floor(seconds / 60) % 60;
    const pSeconds = Math.floor(seconds % 60);
    return trimZero([pHours, pMinutes, pSeconds].map(n => (
        leftPad(n, 2, '0')
    )).join(':'));
};

export default convertToTime;



/** WEBPACK FOOTER **
 ** ./src/utils/convertToTime.js
 **/